import gql from 'graphql-tag';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { statusBannerFire } from 'actions/statusBanner';
import { graphql } from 'graphql/utils';

export const withData = () =>
    compose(
        connect(undefined, { setStatusBanner: statusBannerFire }),
        graphql(
            gql`
                mutation toggleEventEmailNotifications($eventId: ID!, $enabled: Boolean!) {
                    updateEventNotificationsSettings(eventId: $eventId, emailEnabled: $enabled) {
                        event {
                            id
                            emailNotificationsEnabled
                        }
                    }
                }
            `,
            {
                props: ({ mutate, ownProps: { eventId, setStatusBanner } }) => ({
                    toggleAlert: enabled =>
                        mutate({
                            variables: { eventId, enabled }
                        })
                            .then(() => setStatusBanner('Alert settings updated successfully!'))
                            .catch(() => setStatusBanner('Error updating alert settings', 'error', 'circleX'))
                })
            }
        )
    );
